exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mx-datepicker-sidebar{width:150px}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:150px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/V2Datepicker.vue"],"names":[],"mappings":"AACA,uBACI,WAAa,CAChB,AACD,8CACQ,iBAAmB,CAC1B","file":"V2Datepicker.vue","sourcesContent":["\n.mx-datepicker-sidebar {\n    width: 150px;\n}\n.mx-datepicker-sidebar+.mx-datepicker-content {\n        margin-left: 150px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24bd862f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/V2Datepicker.vue
// module id = 2280
// module chunks = 16